import './SearchCompletions.scss';

import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@/common/components/atoms/Button/Button';
import Loader from '@/ebat/components/blocks/Common/Loader/Loader';

import {
  SearchCompletionsDefaultProps,
  SearchCompletionsPropTypes,
} from './SearchCompletions.proptypes';

const SearchCompletions = ({
  className,
  completions,
  isLoading,
  onItemKeyDown,
  selectCompletion,
  setItemRef,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn('search-completions', className)}
      data-qa-id="search-completions"
    >
      {isLoading ? (
        <Loader type="full" />
      ) : (
        <>
          {completions.length > 0 ? (
            <div
              className="search-completions__results"
              data-qa-id="search-completions-results"
            >
              {completions.map(({ key, items }, colIndex) => (
                <div
                  className={`search-completions__list search-completions__list--${key}`}
                  key={`key-${key}-${colIndex}`}
                >
                  <div className="title">
                    {t(`ebat:entities:search.completions.${key}`)}
                  </div>
                  <ul className={`list list--${key}`}>
                    {items.map((completion, rowIndex) => (
                      <li
                        className="list__item"
                        key={`completion-${key}-${completion}-${rowIndex}`}
                      >
                        <Button
                          ref={(ref) => setItemRef(ref, colIndex, rowIndex)}
                          className="search-completion"
                          context="search-completion"
                          onClick={(e) => selectCompletion(e, completion, key)}
                          onKeyDown={(e) =>
                            onItemKeyDown(e, colIndex, rowIndex)
                          }
                        >
                          <span className="label">{completion}</span>
                        </Button>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          ) : (
            <div
              className="search-completions__no-results"
              data-qa-id="search-completions-no-results"
            >
              {t('common:messages:no_results.large')}
            </div>
          )}
        </>
      )}
    </div>
  );
};

SearchCompletions.defaultProps = {
  ...SearchCompletionsDefaultProps,
};

SearchCompletions.propTypes = {
  ...SearchCompletionsPropTypes,
};

export default SearchCompletions;
